export default {
  common: {
    add: "添加",
    delete: "删除",
    detail: "明细",
    modify: "修改",
    search: "查询",
    reset: "重置",
    seq: "序号",
    operation: "操作",
    copy: "复制",
    moveUp: "上移",
    moveDown: "下移",
    errTip: "错误提示"
  },
  login: {
    welcome2Login: "欢迎登录",
    login: "登录",
    reset: "重置"
  },
  navigator: {
    userInfo: "查看个人信息"
  },
  selectLang: {
    switchLang: "切换语言",
    switchLangMsg: "切换语言成功"
  },
  menus: {
    home: "首页",
    flow: "流程中心",
    mail: "收发邮件",
    personal: "个人设置"
  },
  approvalItem: {
    addCommonLanguage: "添加常用语",
    commonLanguageType: "常用语类型",
    commonLanguage: "常用语"
  },
  myLayout: {
    myLayoutName: "布局名称",
    valid:"是否有效",
    setValid:"设为有效"
  },
  eip: {
    common: {
      search: '查询',
      reset: '重置',
      save: '保存',
      cancel: '取消',
      up: '上移',
      down: '下移',
      remove: '删除',
      clear: '清空',
      index: '序号',
      selected: '已选择'
    },
    tree: {
      filterText: '输入关键词过滤'
    },
    selectLang: {
      switchLang: '切换语言'
    }
  }
}